import SettingConstants from "./constants/settings";

export const getDistanceIn = (distance = 0, distanceUnit = "km", quote = 1) => {
  let distanceUnitObj = SettingConstants.distanceUnits.find(
    ({ value }) => value === distanceUnit,
  );

  return (
    (distance / distanceUnitObj.rate2Km ** quote)
      .toFixed(0)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
    " " +
    (quote === 1
      ? distanceUnitObj.label
      : distanceUnit === "km"
        ? "km²"
        : "sqmi.")
  );
};

export const getFormatedNumber = (value = 0) =>
  value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export const getPersistConfigKey = (sholdUpdate = false) => {
  const currentDate = new Date().toLocaleDateString();

  let browserVisitId = localStorage.getItem("browserVisitId");

  if (
    sholdUpdate ||
    !(localStorage.getItem("currentDate") === currentDate && browserVisitId)
  ) {
    localStorage.removeItem(
      "persist:" + localStorage.getItem("browserVisitId"),
    );
    browserVisitId = Math.random().toString(36).substr(2, 9);

    localStorage.setItem("currentDate", currentDate);
    localStorage.setItem("browserVisitId", browserVisitId);
  }

  return browserVisitId;
};

export const getRandomCountryForToday = (maxlimit) => {
  const currentDate = new Date().toLocaleDateString();

  let browserVisitId = localStorage.getItem("browserVisitId");

  const hashCode = hashCodeFromString(`${browserVisitId}-${currentDate}`);
  const seededRandom = seedRandom(hashCode);

  return Math.floor(seededRandom * maxlimit);
};

export const hashCodeFromString = (str) => {
  let hash = 0;
  if (str.length === 0) return hash;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash &= hash;
  }
  return Math.abs(hash);
};

const seedRandom = (seed) => {
  const x = Math.sin(seed++) * 10000;
  return x - Math.floor(x);
};

//Check if guess is correct
export const checkGuessAlpha2Code = (guessItem, answerItem) => {
  //Compare Item codes
  if (guessItem.Alpha2Code === answerItem?.Alpha2Code) {
    return true;
  } else {
    return false;
  }
};

//Check if guess is correct
export const checkGuessName = (guessItem, answerItem) => {
  //Compare Item name
  if (guessItem.name === answerItem.name) {
    return true;
  } else {
    return false;
  }
};

//Check if guess is correct
export const checkGuessAlpha2Codes = (guessItems, answerItems) => {
  const guessCodes = guessItems.map(({ Alpha2Code }) =>
    Alpha2Code.toUpperCase(),
  );
  const answerCodes = answerItems.map((item) => item.toUpperCase());

  return answerCodes.every((code) => guessCodes.includes(code));
};

//Check if guess is correct
export const checkCorrectNeighbour = (Alpha2Code, answerItems) => {
  return (
    !!Alpha2Code &&
    !!answerItems?.length &&
    answerItems.includes(Alpha2Code.toUpperCase())
  );
};

export const isObjectInArray = (obj, objArray) => {
  return objArray.map((item) => item.Alpha2Code).includes(obj.Alpha2Code);
};

export const getFlagMode = (
  item,
  selectedArray = [],
  correctItem = {},
  completed = false,
) => {
  const isGuessed = isObjectInArray(item, selectedArray);
  const isCorrect = checkGuessAlpha2Code(item, correctItem);

  if ((completed || isGuessed) && isCorrect) return 0;
  else if (isGuessed && !isCorrect) return 1;
  else if (completed && !isGuessed && !isCorrect) return 2;
  else return -1;
};

export const getAreaMode = (
  item,
  selectedArray = [],
  correctItem = {},
  completed = false,
) => {
  const isGuessed = selectedArray.includes(item);
  const isCorrect = item === correctItem;

  if ((completed || isGuessed) && isCorrect) return 0;
  else if (isGuessed && !isCorrect) return 1;
  else if (completed && !isGuessed && !isCorrect) return 2;
  else return -1;
};

export const getAreaModeBySpokenLanguage = (
  item,
  selectedArray = [],
  correctItems = [],
  completed = false,
) => {
  const isGuessed = selectedArray.includes(item);
  const isCorrect = correctItems.includes(item);

  if ((completed || isGuessed) && isCorrect) return 0;
  else if (isGuessed && !isCorrect) return 1;
  else if (completed && !isGuessed && !isCorrect) return 2;
  else return -1;
};

export const getCityCardMode = (
  cityName = "",
  correctAnswer = {},
  completed = false,
) => {
  const isCorrect = cityName === correctAnswer.name;

  if (completed && isCorrect) return 0;
  else if (completed && !isCorrect) return 1;
  else return -1;
};

export const calculateCountryCorrectness = (country1, country2) => {
  const degreesToRadians = (degrees) => {
    return degrees * (Math.PI / 180);
  };

  const lat1 = degreesToRadians(country1.Latitude);
  const lon1 = degreesToRadians(country1.Longitude);
  const lat2 = degreesToRadians(country2.Latitude);
  const lon2 = degreesToRadians(country2.Longitude);

  const deltaLon = lon2 - lon1;

  const y = Math.sin(deltaLon) * Math.cos(lat2);
  const x =
    Math.cos(lat1) * Math.sin(lat2) -
    Math.sin(lat1) * Math.cos(lat2) * Math.cos(deltaLon);
  let bearing = Math.atan2(y, x);

  // Convert bearing from radians to degrees
  bearing = (bearing * 180) / Math.PI;

  // Normalize bearing to range from 0 to 360 degrees
  bearing = (bearing + 360) % 360;

  let direction = (Math.floor((bearing + 22.5) / 45) % 8) + 1;

  // Haversine formula to calculate distance between two points on Earth
  const R = 6371; // Earth's radius in kilometers
  const dLat = lat2 - lat1;
  const dLon = lon2 - lon1;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;

  // Calculate percent
  const maxDistance = Math.PI * R; // Diameter of the Earth
  const percent = 100 - (distance / maxDistance) * 100;

  const sizePercent = (country2.area * 100) / country1.area;
  return { bearing, direction, distance, percent, sizePercent };
};

export const adjustGridRowAndCol = (count) => {
  if (count < 2) return 1;
  else if (count === 3) return 3;
  else if (count < 5) return 2;
  else if (count < 9) return 3;
  else return 4;
};

export const sampleSevenItems = (items, excludedMe, numSamples = 7) => {
  const filteredArray = items
    .filter((item) => excludedMe !== item.Alpha2Code)
    .sort(() => Math.random() - 0.5)
    .slice(0, numSamples);
  const excludedMeItem = items.find((item) => item.Alpha2Code === excludedMe);

  return [...filteredArray, excludedMeItem].sort(() => Math.random() - 0.5);
};

export const sampleStringItems = (items, excludedMes, numSamples = 3) => {
  const filteredArray = items
    .filter((item) => !excludedMes.includes(item))
    .sort(() => Math.random() - 0.5)
    .slice(0, numSamples - excludedMes.length);

  return [...filteredArray, ...excludedMes].sort(() => Math.random() - 0.5);
};

export const sampleLanguageItems = (items, excludedMes, numSamples = 3) => {
  const filteredArray = items
    .filter((item) => !excludedMes.includes(item.language))
    .sort(() => Math.random() - 0.5)
    .slice(0, numSamples - excludedMes.length);

  const excludedMeItems = items.filter((item) =>
    excludedMes.includes(item.language),
  );
  return [...filteredArray, ...excludedMeItems].sort(() => Math.random() - 0.5);
};

export const checkSubArrayIncludes = (items, subArray) => {
  return subArray.filter((item) => !items.includes(item)).length === 0;
};

export function generateOptions(targetValue, distanceUnit = "km") {
  let distanceUnitObj = SettingConstants.distanceUnits.find(
    ({ value }) => value === distanceUnit,
  );

  const targetValueInUnit = targetValue / distanceUnitObj.rate2Km ** 2;

  const uniteLabel = distanceUnitObj.square;

  const stepSize =
    targetValueInUnit < 1
      ? 0.001
      : targetValueInUnit < 1000
        ? 1
        : targetValueInUnit < 1000000
          ? 1000
          : 1000000;
  const stepLabel =
    targetValueInUnit < 1
      ? "1E-3"
      : targetValueInUnit < 1000
        ? ""
        : targetValueInUnit < 1000000
          ? "K"
          : "M";

  const scale = 250;
  const correctOption = Math.floor(targetValueInUnit / (stepSize * scale)) + 1;

  const options = [
    `< ${[getFormatedNumber(scale * 1), stepLabel, uniteLabel].join(" ")}`,
    `${[getFormatedNumber(scale * 1), stepLabel, uniteLabel].join(" ")} ~ ${[
      getFormatedNumber(scale * 2),
      stepLabel,
      uniteLabel,
    ].join(" ")}`,
    `${[getFormatedNumber(scale * 2), stepLabel, uniteLabel].join(" ")} ~ ${[
      getFormatedNumber(scale * 3),
      stepLabel,
      uniteLabel,
    ].join(" ")}`,
    `${[getFormatedNumber(scale * 3), stepLabel, uniteLabel].join(" ")} ~ ${[
      getFormatedNumber(scale * 4),
      stepLabel,
      uniteLabel,
    ].join(" ")}`,
  ];

  return {
    options,
    answer: options[correctOption - 1],
  };
}

export const throttle = (func, delay) => {
  let lastCalled = 0;
  return function (...args) {
    const now = Date.now();
    if (now - lastCalled >= delay) {
      let result = func(...args);
      lastCalled = now;
      return result;
    }
  };
};
